import {
  getAction,
  deleteAction,
  putAction,
  postAction,
  fromDataPutAction,
  httpAction,
  fromDataPostAction,
  fromDataPostActionMultipart,
} from "@/api/manage";

// 移仓单
export const getLatticeNotificationForOutBound = (params) =>
  getAction("/wmslattice/getLatticeNotificationForOutBound", params); //根据物品id、批号、库存编号获取库存数量
export const shiftAdd = (params) => postAction("/shift/add", params); // 新建移仓
export const queryShiftDetailInfo = (params) =>
  getAction("/shift/queryShiftDetailInfo", params); // 移仓--任务明细详情
export const queryShiftInfo = (params) =>
  getAction("/shift/queryShiftInfo", params); // 移仓-任务详情
export const recordArchive = (params) =>
  fromDataPutAction("/archive/recordArchive", params); // 记录归档
export const deleteShiftInfo = (params) =>
  deleteAction("/shift/deleteById", params); // 删除
export const getLatticeInfoForScan = (params) =>
  getAction("/wmslattice/getLatticeInfoForScan", params); // 右上角-扫码-库位获取物品
